import { Component } from "@angular/core";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { InsiderToMap } from "../../../../../api/models/insider-to-map";
import { filter } from "rxjs/operators";
import { MessageService } from "primeng/api";
import {
  InsiderMappingService
} from "../../../../../api/services/insider-mapping.service";
import { sanitizeForm } from "../../../../../core/utils/form-clean";
import {
  InsiderRelationship,
  InsiderType,
  RelationshipToIssuer,
  MappedInsiderDetail,
} from "src/api/models";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";
import GetMappedInsidersByIssuerIdParams = InsiderMappingService.GetMappedInsidersByIssuerIdParams;
type FormData = {
  affiliateName: string;
  cik: string;
  p2iq: string;
  parentInsiderName: string;
  parentCik: string;
  insiderComment:string
};

// Only string keys of formData
type StringFormDataKeys = {
  [K in keyof FormData]: FormData[K] extends string ? K : never;
}[keyof FormData];
type PasteField = StringFormDataKeys | keyof MapInsiderDataComponent;
@Component({
  selector: "app-map-insider-data",
  // imports: [],
  templateUrl: "./map-insider-data.component.html",
  styleUrl: "./map-insider-data.component.css",
  standalone: false,
})
export class MapInsiderDataComponent {
  insiders: any[] = [];
  selectedInsiders: any[] = [];
  secondTableInsiders: any[] = [];
  selectedDialogRow: any = null;
  searchInsider: string = "";
  parentSearchInsider: string = "";
  reportingEntityType: InsiderType | undefined;
  // showDropdown = false;
  showChildDropdown = false;
  showParentDropdown = false;
  filteredInsiders: any[] = [];
  parentFilteredInsiders: any[] = [];

  remap = false;
  showParentForm: boolean = false;
  isIndividual: boolean = false;
  // Pagination for Issuers
  First = 0;
  Rows = 10;
  activeStatusTab: "unprocessed" | "processed" = "unprocessed";
  parentFormData = {
    parentInsiderName: "",
    parentCik: "",
    insiderrelationshipreason: undefined,
    p2iq: "",
    insiderComment:""
  };

  childFormData = {
    araId: undefined as number | undefined,
    affiliateName: "",
    cik: "",
    p2iq: "",
    insiderComment:""

  };
  isLoading: boolean = false;
  selectedInsiderOption: any = null;
  insiderSuggestions: any[] = [];
  selectedInsider: any = null;
  relationshipOptions: { label: string; value: string }[] = [];
  insiderList: { label: string; value: MappedInsiderDetail }[] = [];
  selectedMappedInsider: MappedInsiderDetail | null = null;
  selectedParentMappedInsider: MappedInsiderDetail | null = null;
  validationErrors = {
    affiliateName: "",
  };
  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public insiderMappingService: InsiderMappingService,
    public dialogService: DialogService,
    public _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.selectedInsiders = this.config.data.insiders;
    this.insiders = [...this.config.data.insiders];
    this.isIndividual =
      this.insiders[0]?.asReportedReportingEntityType === "INDIVIDUAL";
    this.remap = this.config.data.remap;
    this.relationshipOptions = InsiderRelationship.values().map((v) => ({
      label: v,
      value: v,
    }));
    this.loadMappedInsiders();
  }
  private loadMappedInsiders(): void {
    // Get asReportedIssuerId from selectedInsiders
    const asReportedIssuerId = this.selectedInsiders[0]?.asReportedIssuerId;
    const issuerId = this.selectedInsiders[0]?.issuerId;

    if (!asReportedIssuerId && !issuerId) {
      return;
    }

    const params: GetMappedInsidersByIssuerIdParams = {
      asReportedIssuerId: asReportedIssuerId,
      issuerId: issuerId
    };

    this.isLoading = true;
    this.insiderMappingService.getMappedInsidersByIssuerId(params).subscribe({
      next: (data: MappedInsiderDetail[]) => {
        this.insiderList = data.map((insider) => ({
          label: insider.insiderName || "N/A",
          value: insider,
        }));
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          severity: "error",
          summary: err.error?.message || "Failed to fetch mapped insiders",
        });
        this.insiderList = [];
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  private bindParentFormData(product: any) {
    this.parentFormData = {
      parentInsiderName: product.asReportedInsiderName || "",
      parentCik: product.insiderCik || "",
      insiderrelationshipreason: product.insiderRelationshipreason || undefined,
      p2iq: product.p2iq || "",
    insiderComment:product.insiderComment || ""

    };
  }
  private bindChildFormData(product: any) {

    this.childFormData = {
      araId:
        typeof product.asReportedInsiderId === "number"
          ? product.asReportedInsiderId
          : undefined,
      affiliateName: product.asReportedInsiderName || "",
      cik: product.insiderCik || "",
      p2iq: product.p2iq || "",
      insiderComment:product.insiderComment || ""
    };
    // Clear validation errors when form data is bound
    this.validationErrors = {
      affiliateName: "",
    };
  }
  private clearParentFormData() {
    this.parentFormData = {
      parentInsiderName: "",
      parentCik: "",
      insiderrelationshipreason: undefined,
      p2iq: "",
      insiderComment:""
    };
  }
  private clearChildFormData() {
    this.childFormData = {
      affiliateName: "",
      cik: "",
      araId: undefined,
      p2iq: "",
      insiderComment:""
    };
    // Clear validation errors when form is cleared
    this.validationErrors = {
      affiliateName: "",
    };
  }
  onDialogRowSelect(event: any) {
    this.selectedDialogRow = event.data;
    this.bindChildFormData(event.data);
  }
  onDialogRowUnselect(product: any) {
    if (this.childFormData?.araId === product.data.araId) {
      this.clearChildFormData();
    }
  }
  onSubmit() {
    // Reset validation errors
    this.validationErrors = {
      affiliateName: "",
    };

    // Validate required fields
    let isValid = true;
    if (!this.childFormData.affiliateName || !this.childFormData.affiliateName.trim()) {
      this.validationErrors.affiliateName = "Insider Name is required";
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    const cleanedParent = sanitizeForm(this.parentFormData);
    const cleanedChild = sanitizeForm(this.childFormData);
    const isParentEmpty =
      !cleanedParent.parentCik &&
      !cleanedParent.parentInsiderName &&
      !cleanedParent.insiderrelationshipreason;
    const params: InsiderToMap = {
      asReportedInsiderIds: this.insiders
        .map((insider) => insider.asReportedInsiderId)
        .filter((id): id is number => typeof id === "number"),
      reason: this.remap
        ? "Remapped to correct curated id successfully"
        : "Mapped to curated id successfully",
      insiderType: this.isIndividual ? "INDIVIDUAL" : "NON-INDIVIDUAL",
      secondaryInsider: isParentEmpty
        ? undefined
        : {
            insiderCik: cleanedParent.parentCik?.trim() || undefined,
          insiderName: cleanedParent.parentInsiderName?.trim() || undefined,
          insiderRelationshipReason:
            cleanedParent.insiderrelationshipreason,
          p2iq: cleanedParent.p2iq?.trim() || undefined,
          insiderComment:cleanedParent.insiderComment?.trim()|| undefined
          },

      theInsider: {
        insiderName: cleanedChild.affiliateName?.trim() || undefined,
      insiderCik: cleanedChild.cik?.trim() || undefined,
      p2iq: cleanedChild.p2iq?.trim() || undefined,
        insiderComment:cleanedChild.insiderComment?.trim()|| undefined
      },
    };

    this.isLoading = true;
    this.insiderMappingService.doMapTheInsider(params).subscribe({
      next: (value) => {},
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.isLoading = false;
        this.ref.close({ refresh: true });
      },
    });
  }
  onCancel() {
    this.ref.close();
  }
  // child search
  onChildSearchEnter() {
    const query = this.searchInsider.trim();
    if (!query) return;

    this.isLoading = true;
    this.insiderMappingService.getInsidersByInsiderName(query).subscribe({
      next: (data) => {
        let issuerCik: string | undefined;

        if (this.selectedInsiders.length > 0) {
          issuerCik = this.selectedInsiders[0]?.asReportedIssuerCik;
        }

        if (issuerCik) {
          const cikExists = data.some(
            (insider: any) => insider.companyCik === issuerCik
          );
          if (cikExists) {
            this.filteredInsiders = data.filter(
              (insider: any) => insider.companyCik === issuerCik
            );
          } else {
            this.filteredInsiders = data;
          }
        } else {
          this.filteredInsiders = data;
        }

        this.showChildDropdown = this.filteredInsiders.length > 0;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          severity: "error",
          summary: err.error?.message || "Failed to fetch insiders",
        });
        this.filteredInsiders = [];
        this.showChildDropdown = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  // parent search
  onParentSearchEnter() {
    const query = this.parentSearchInsider.trim();
    if (!query) return;

    this.isLoading = true;
    this.insiderMappingService.getInsidersByInsiderName(query).subscribe({
      next: (data) => {
        let issuerCik: string | undefined;

        if (this.selectedInsiders.length > 0) {
          issuerCik = this.selectedInsiders[0]?.asReportedIssuerCik;
        }

        if (issuerCik) {
          const cikExists = data.some(
            (insider: any) => insider.companyCik === issuerCik
          );
          if (cikExists) {
            this.parentFilteredInsiders = data.filter(
              (insider: any) => insider.companyCik === issuerCik
            );
          } else {
            this.parentFilteredInsiders = data;
          }
        } else {
          this.parentFilteredInsiders = data;
        }

        this.showParentDropdown = this.parentFilteredInsiders.length > 0;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          severity: "error",
          summary: err.error?.message || "Failed to fetch insiders",
        });
        this.parentFilteredInsiders = [];
        this.showParentDropdown = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  onInsiderSelect(eventOrInsider: any) {
    // Handle dropdown onChange event (event.value contains MappedInsiderDetail)
    let insider: any;
    const isFromDropdown = eventOrInsider && eventOrInsider.value;

    if (isFromDropdown) {
      // Extract MappedInsiderDetail from dropdown event
      const mappedInsider: MappedInsiderDetail = eventOrInsider.value;
      // Convert to same format as filtered insiders (include insiderComment from API)
      insider = {
        asReportedInsiderName: mappedInsider.insiderName,
        insiderCik: mappedInsider.insiderCik,
        companyName: mappedInsider.issuerName,
        p2iq: mappedInsider.p2iq,
        insiderComment: mappedInsider.insiderComment,
      };
      this.selectedMappedInsider = mappedInsider;
    } else {
      // Handle direct insider object (from filtered insiders list)
      insider = eventOrInsider;
    }
    // Same logic as original
    this.selectedInsider = insider;
    // Only update searchInsider if selection is from filtered list, not from dropdown
    if (!isFromDropdown) {
      this.searchInsider = insider.asReportedInsiderName || "";
    }
    this.showChildDropdown = false;
    this.secondTableInsiders = [insider];
    // Auto-select the row and bind form so insider comment and other fields display immediately
    this.selectedDialogRow = insider;
    this.bindChildFormData(insider);
  }
  onParentInsiderSelect(eventOrInsider: any) {
    if (!this.showParentForm) {
      return;
    }

    // Handle dropdown onChange event (event.value contains MappedInsiderDetail)
    let insider: any;
    if (eventOrInsider && eventOrInsider.value) {
      // Extract MappedInsiderDetail from dropdown event
      const mappedInsider: MappedInsiderDetail = eventOrInsider.value;
      // Convert to same format as filtered insiders (include insiderComment from API)
      insider = {
        asReportedInsiderName: mappedInsider.insiderName,
        insiderCik: mappedInsider.insiderCik,
        p2iq: mappedInsider.p2iq,
        insiderComment: mappedInsider.insiderComment,
      };
      this.selectedParentMappedInsider = mappedInsider;
    } else {
      // Handle direct insider object (from filtered insiders list)
      insider = eventOrInsider;
    }

    // Same logic as original
    this.bindParentFormData(insider);
    this.showParentDropdown = false;
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
onPaste(event: ClipboardEvent, field: PasteField): void {
  handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
    // Check if the field exists in childFormData
    if (field in this.childFormData) {
      // @ts-ignore
      this.childFormData[field] = newValue;
    }
    // Check if the field exists in parentFormData
    else if (field in this.parentFormData) {
      // @ts-ignore
      this.parentFormData[field] = newValue;
    } else {
       (this as any)[field] = newValue;
      // Handle case if the field doesn't exist in either formData
      console.error(`Field ${field} not found in either formData`);
    }
  });
}

}
